class MenuInfoCollection {
    index: number;

    id: string;

    width: number;

    depth: number;

    name: string;
}
export default MenuInfoCollection;
